/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Components */
import UCModal from "../../ucmodal";
import UCButton from "../../buttons";
import IframeModal from '../iframeModal';
import { ReactComponent as HelpSvg } from "../../../resources/images/help.svg";
import { AC_BUSINESS_SUPPORT_URL, AC_BUSINESS_SUPPORT_URL_FR, AC_TECHNICAL_SUPPORT_URL, ACCEPTED_LANGUAGES } from '../../../constants/appConstants';
import { useLocaleContext } from '../../../contexts/localeContext';


/* Styles */
import styles from "./styles";

const NavigationHelpACModal = ({ showModal, setShowModal }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const [selectedUrl, setSelectedUrl] = useState(null);
  const locale = useLocaleContext();
  const businessSupportUrl = ACCEPTED_LANGUAGES[locale]?.startsWith('FR') && AC_BUSINESS_SUPPORT_URL_FR ? AC_BUSINESS_SUPPORT_URL_FR : AC_BUSINESS_SUPPORT_URL;

  const handleClose = () => {
    setShowModal(false);
    setSelectedUrl(null);
  };

  return (
    <>
      <UCModal
        className={classes.navigationHelpACModal}
        showModal={showModal && !selectedUrl}
        setShowModal={handleClose}
        modalHeaderTitle={
          <>
            <div className={classes.iconWrapper}><HelpSvg /></div>
            <div className={classes.textWrapper}>
              <div className={classes.title}>
                <FormattedMessage id="navigationHelpModal.AC.title" />
              </div>
              <div className={classes.desc}>
                <FormattedMessage id="navigationHelpModal.AC.description" />
              </div>
            </div>
          </>
        }
        modalTitle={<hr className={classes.divider} />}
        modalContent={
          <div className={classes.cards}>
            <div className={classes.card}>
              <p className={classes.cardTitle}>
                <FormattedMessage id="navigationHelpACModal.technicalSupport.title" />
              </p>
              <p className={classes.cardDescription}>
                <FormattedMessage id="navigationHelpACModal.technicalSupport.description" />
              </p>
              <UCButton
                type="danger"
                className={classes.continueBtn}
                text={<FormattedMessage id="navigationHelpACModal.continue" />}
                onClick={() => setSelectedUrl(AC_TECHNICAL_SUPPORT_URL)}
              />
            </div>
            <div className={classes.card}>
              <p className={classes.cardTitle}>
                <FormattedMessage id="navigationHelpACModal.businessSupport.title" />
              </p>
              <p className={classes.cardDescription}>
                <FormattedMessage id="navigationHelpACModal.businessSupport.description" />
              </p>
              <UCButton
                type="danger"
                className={classes.continueBtn}
                text={<FormattedMessage id="navigationHelpACModal.continue" />}
                onClick={() => setSelectedUrl(businessSupportUrl)}
              />
            </div>
          </div>
        }
        dataTestId="navigationhelpacmodal"
      />
      <IframeModal
        selectedUrl={selectedUrl}
        setSelectedUrl={setSelectedUrl}
        dataTestId="navigationhelpacmodal-iframe"
      />
    </>
  );
};

export default NavigationHelpACModal;
